module.exports = __webpack_public_path__ + "static/media/image-4.2117bef0.png";